module.exports = __webpack_public_path__ + "static/media/dinersclub.e51c7930.png";